import alt from '../alt';
import modalAction from '../actions/modalAction';

class attdAction {
    constructor() {
        this.generateActions(
            'search',
            'processing',
            'getAllStaffAtdSuccess',
            'getStaffAtdSuccess',
            'selectedMonth',
            'shouldListShow',
            'shouldDDListShow',
            'updateAttandanceSuccess',
            'attendanceId',
            'closeListShow',
            'attendanceCheckSuccess',
            'canSubmit'
        );
    }
    checkInitAttendance() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/attendance/officeCheck', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.attendanceCheckSuccess(result);
                        this.canSubmit(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);

                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
    }
    timeIn(remark) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/attendance/officeIn', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.attendanceId(result);
                        modalAction.modalContent({ title: "Time In", content: "Done. Data recorded" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);

                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ remark: remark }));
        }
        return true;
    }
    timeOut(attendanceId, remark) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/attendance/officeOut', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.attendanceId("");
                        modalAction.modalContent({ title: "Time Out", content: "Done. Data recorded" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);

                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ _id: attendanceId, remark: remark }));
        }
        return true;
    }
    getAllStaffAttendance(year, month) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/allStaffAttendance?year=' + year + "&month=" + month, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.getAllStaffAtdSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);

                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }

    getStaffAttendance(staffId, year, month) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/staffAttendance/' + staffId + "?year=" + year + "&month=" + month, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.getStaffAtdSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);

                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        //this.processing(false);
        return true;
    }

    exportAllStaffAttendance(year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/allStaffAttendance', true);
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
           
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "AttendanceReport_All_" + year + "-" + (month + 1) + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);

                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ year: year, month: month }));
        }
        return true;
    }

    exportStaffAttendance(staffId, year, month) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/staffAttendance/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = staffId + "AttendanceReport_" + staffId + "_" + year + "-" + (month + 1) + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {

                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }

                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ year: year, month: month }));
        }
        return true;
    }

    updateAttandance(_id, staffId, year, month, date, startTime, endTime, startRemark, endRemark) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/staffAttendance/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.updateAttandanceSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                _id: _id,
                year: year,
                month: month,
                date: date,
                startTime: startTime,
                endTime: endTime,
                startRemark: startRemark,
                endRemark: endRemark
            }));
        }
        return true;
    }
}
export default alt.createActions(attdAction);


// WEBPACK FOOTER //
// ./app/actions/attdAction.js